import { Navigate, Outlet } from 'react-router';
import { useSubscription } from '../../hooks/subscription/use-subscription';
import { isGuardQuerySettling } from './guard-query-state';

interface DdtAddonGuardProps {
  redirectTo?: string;
}

/**
 * Route guard for the Customers / Transport Documents (DDT) add-on.
 * Mirrors PermissionGuard's shape but checks `SubscriptionInfo.ddtAddonEnabled`
 * instead of a role permission — this is a per-tenant add-on toggle set by
 * platform-admin (`PATCH /admin/tenants/:id/ddt-addon`), not a role grant.
 */
export function DdtAddonGuard({ redirectTo = '/home' }: DdtAddonGuardProps) {
  const { ddtAddonEnabled, isPending, fetchStatus } = useSubscription();
  if (isGuardQuerySettling({ isPending, fetchStatus })) {
    return null;
  }
  if (!ddtAddonEnabled) {
    return <Navigate to={redirectTo} replace />;
  }
  return <Outlet />;
}
